import React, { useState } from "react";
import FieldBox from "../../../utils/Form/ui/FieldBox";
import Modal from "../../../components/ui/Modal/Modal";

const InvoiceEditModal = (props) => {
  const { setCloseModal } = props;
  const [isInputEnabled, setInputEnabled] = useState(false);
  const [closeConfirmationModal, setCloseConfirmationModal] = useState(false);

  const enableInput = () => {
    setInputEnabled(!isInputEnabled);
  };

  const handleCloseConfirmationModal = () => {
    setCloseConfirmationModal(!closeConfirmationModal);
  };
  const handleCloseEditInvoice = () => {
    setCloseModal(true);
  };
  return (
    <div>
      <div className="border-b flex items-center px-5 pt-1 pb-3 justify-between">
        <h1 className="font-bold text-sm">운송장 정보 수정</h1>
        <Modal
          hasCancel={false}
          hasSubmit={false}
          description={
            <div>
              <p>입력을 취소하시겠습니까? 입력한 정보는 저장되지 않습니다.</p>
              <div className="flex -mb-3 justify-end mt-3">
                <button className="border rounded-[4px] border-black w-16 mr-2 p-1">
                  취소
                </button>
                <button
                  onClick={handleCloseEditInvoice}
                  className="border w-16 p-1 rounded-[4px] text-white bg-primary-blue border-primary-blue"
                >
                  확인
                </button>
              </div>
            </div>
          }
        >
          <button className="border rounded-[4px] border-button-grey w-20 py-1">
            닫기
          </button>
        </Modal>
      </div>
      <div className="mt-4 bg-primary-blue border border-primary-blue mx-5 px-3 py-2 text-white">
        상품정보
      </div>
      <div className="flex px-5 items-center">
        <div className="w-1/2">
          <FieldBox splitted label="카테고리">
            <span>카테고리</span>
          </FieldBox>
        </div>
        <div className="w-1/2">
          <FieldBox splitted splittedWidth="w-[40%]" label="REF(상품코드)">
            <span>상품코드명</span>
          </FieldBox>
        </div>
      </div>
      <div className="px-5">
        <FieldBox isLast label="상품명">
          <span>상품명 입니다.</span>
        </FieldBox>
      </div>
      <div className="border-4 my-4 border-line-grey"></div>
      <div className="px-5">
        <div className="flex justify-between">
          <p className="font-bold">운송장 정보</p>
          <p>
            ※ '송장번호 수정'을 누른 후, 수정할 송장번호 입력한 다음
            '수정완료'를 눌러주세요. 입력을 취소할 경우 상단 '닫기'를
            눌러주세요.
          </p>
        </div>
        <div className="flex mt-2 w-full">
          <div className="flex w-full">
            <div className="bg-input-grey w-40 border py-2 px-4 border-primary-grey">
              택배사 정보
            </div>
            <div className="relative flex w-full">
              <input
                type="text"
                className="border w-full outline-none border-r-0 px-2 border-l-0 pr-12"
                value={`한진택배`}
              />

              {!isInputEnabled ? (
                <button
                  onClick={enableInput}
                  className={`text-secondary-blue border-secondary-blue border h-6  rounded-[4px] absolute inset-y-0 right-2 top-1.5 px-2`}
                >
                  송장번호 수정
                </button>
              ) : (
                <Modal
                  hasCancel={false}
                  hasSubmit={false}
                  triggerClose={closeConfirmationModal}
                  padding="p-0"
                  description={
                    <div className="px-5 -mb-2 mt-3">
                      수정완료 하시겠습니까? 수정완료를 할 경우, 고객, admin에
                      등록된
                      <br />
                      [배송추적] 정보가 변경됩니다.
                      <div className="flex justify-end mt-2">
                        <button
                          onClick={handleCloseConfirmationModal}
                          className="border rounded-[4px] border-black w-16 mr-2 p-1"
                        >
                          취소
                        </button>
                        <button
                          className="border w-16 p-1 rounded-[4px] text-white bg-primary-blue border-primary-blue"
                          onClick={enableInput}
                        >
                          확인
                        </button>
                      </div>
                    </div>
                  }
                >
                  <button
                    className={`text-white border-secondary-blue bg-secondary-blue border h-6  rounded-[4px] absolute inset-y-0 right-2 top-1.5 px-2`}
                  >
                    수정완료
                  </button>
                </Modal>
              )}
            </div>
          </div>

          <div className="flex w-full">
            <div className="bg-input-grey border w-40 py-2 px-4 border-primary-grey">
              송장번호
            </div>
            <input
              type="text"
              placeholder="송장번호를 정확히 입력해주세요."
              className={`${
                !isInputEnabled && "bg-disable-grey"
              } border w-full outline-none px-2 border-l-0`}
              value={`1234567899`}
              disabled={!isInputEnabled}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceEditModal;
